let paymentProviderReadsEnabled = false;
let paymentProviderReadOverrideAllowed = false;

/** True when business-api uses new payment provider reads (`USE_NEW_PAYMENT_PROVIDER_READ`). */
export function isPaymentProviderReadsEnabled(): boolean {
  return paymentProviderReadsEnabled;
}

/** True when business-api allows `canonicalReads` query override (QA; `ALLOW_CANONICAL_PAYMENT_READ_QUERY_OVERRIDE`). */
export function isPaymentProviderReadOverrideAllowed(): boolean {
  return paymentProviderReadOverrideAllowed;
}

function businessApiRootWithApiPrefix(baseApiUrl: string): string {
  const b = baseApiUrl.replace(/\/$/, "");
  return b.endsWith("/api") ? b : `${b}/api`;
}

export async function loadPaymentFeatureFlags(baseApiUrl: string): Promise<void> {
  const normalizedBase = businessApiRootWithApiPrefix(baseApiUrl);
  try {
    const res = await fetch(`${normalizedBase}/feature-flags/payments`, {
      method: "GET",
      credentials: "omit",
      headers: { Accept: "application/json" },
    });
    if (!res.ok) {
      paymentProviderReadsEnabled = false;
      paymentProviderReadOverrideAllowed = false;
      return;
    }
    // business-api wraps JSON as { statusCode, message, data } (ResponseInterceptor).
    const body = (await res.json()) as {
      payments?: { useCanonicalPaymentReads?: boolean; allowCanonicalPaymentReadQueryOverride?: boolean };
      data?: { payments?: { useCanonicalPaymentReads?: boolean; allowCanonicalPaymentReadQueryOverride?: boolean } };
    };
    const payments = body?.data?.payments ?? body?.payments;
    paymentProviderReadsEnabled = !!payments?.useCanonicalPaymentReads;
    paymentProviderReadOverrideAllowed = !!payments?.allowCanonicalPaymentReadQueryOverride;
  } catch {
    paymentProviderReadsEnabled = false;
    paymentProviderReadOverrideAllowed = false;
  }
}
